module.exports = __webpack_public_path__ + "img/1.a3c9f1e7.png";